import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const resourceLoaded = (payload = null) => ({ type: ACTION.RESOURCE_SUCCESS, payload })
export const resourceBase = () => ({ type: ACTION.RESOURCE_BASE })
export const resourceLoading = () => ({ type: ACTION.RESOURCE_LOADING })

// const arrayToObject = (array) =>
//    array.reduce((obj, item) => {
//      obj[item.id] = item
//      return obj
//    }, {})

export const getResources = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(resourceLoading())
    apiService.getResources()
    .then(response => {
      dispatch(resourceLoaded(response))
      resolve(response)
    })
    .catch(error => {
      dispatch(resourceBase())
      reject(error)
    })
  })
}
